const $inject = ['$http', '$q', 'APP_CONFIG'];

const unusedCreditsService = function unusedCreditsService($http, $q, APP_CONFIG) {
  let service = {
    get,
    set,
    getTravellerSectorsGrouped,
    getAllTravellerSectorsGrouped,
    findGroupIdsFoundInEverySector,
    getAllTravellerAllSectorsGrouped,
    addUnusedCredit,
    populateEachPaxWithSelectedUnusedCredits,
    doGroupIdsMatchToInvoiceUnusedCredit,
    checkAllPaxPaymentsSelected,
    purgeDuplicateUnusedCredits,
    checkForCVV,
    addCVVsToPayments,
    updatedPaxWithPayments: undefined,
    unusedCredits: [],
    activeGroupedSectors: [],
    activeAllSectors: [],
    activeSelectedAllPayment: undefined,
    overrideSectorPaymentChoice: {},
    selectedUnusedCredits: {},
  };

  function get(itineraryId) {
    let deferred = $q.defer();

    $http
      .get(APP_CONFIG.api.root + `api/Itinerary/${itineraryId}/UnusedCredit`, {})
      .then((response) => {
        let data = response.data;
        deferred.resolve(data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }

  function set(data) {
    service.unusedCredits = data;
  }

  function getTravellerSectorsGrouped(traveller) {
    return _.flowRight(createGroupDescriptions, createPaymentOptionsArray, createSectorGrpArray, createSectorArray)(traveller);
  }

  function getAllTravellerSectorsGrouped(travellers) {
    let sectors = [];

    _.forEach(travellers, (traveller) => {
      sectors.push(createSectorArray(traveller));
    });

    sectors = _.flatten(sectors);

    return _.flowRight(
      checkUnusedCreditsIncludeEveryGroupId,
      combineGroupIds,
      groupSectorTypes,
      createGroupDescriptions,
      createPaymentOptionsArray,
      createSectorGrpArray
    )(sectors);
  }

  function createSectorArray(traveller) {
    const sectors = [];

    if (traveller.Flights.length > 0) {
      sectors.push({
        sectorType: 'flights',
        sectors: traveller.Flights,
      });
    }

    if (traveller.Hotels.length > 0) {
      sectors.push({
        sectorType: 'hotels',
        sectors: traveller.Hotels,
      });
    }

    if (traveller.Cars.length > 0) {
      sectors.push({
        sectorType: 'cars',
        sectors: traveller.Cars,
      });
    }

    if (traveller.Rails.length > 0) {
      sectors.push({
        sectorType: 'rails',
        sectors: traveller.Rails,
      });
    }

    return sectors;
  }

  function createSectorGrpArray(sectors) {
    return _.map(sectors, (sectorType) => {
      sectorType.groups = [];

      _.forEach(sectorType.sectors, (sector) => {
        const group = _.find(sectorType.groups, (group) => {
          return group.groupId === sector.GroupIdentifier;
        });

        if (!group) {
          sectorType.groups.push({
            groupId: sector.GroupIdentifier,
            sectors: [sector],
          });
        } else {
          group.sectors.push(sector);
        }
      });

      return sectorType;
    });
  }

  function createPaymentOptionsArray(groupedSectors) {
    const unusedCredits = service.unusedCredits;

    return _.map(groupedSectors, (sectorType) => {
      _.forEach(sectorType.groups, (group) => {
        group.paymentOptions = _.filter(unusedCredits, (unusedCredit) => {
          return unusedCredit.SectorGroups.indexOf(group.groupId) > -1;
        });
      });

      return sectorType;
    });
  }

  function createGroupDescriptions(groupedSectors) {
    return _.map(groupedSectors, (sectorGroup) => {
      _.forEach(sectorGroup.groups, (group) => {
        const descriptions = [];

        if (sectorGroup.sectorType === 'flights') {
          _.forEach(group.sectors, (sector) => {
            descriptions.push(`${sector.Carrier} ${sector.FlightNumber}`);
          });
        }

        if (sectorGroup.sectorType === 'hotels') {
          _.forEach(group.sectors, (sector) => {
            descriptions.push(`${sector.HotelName}`);
          });
        }

        group.groupDescriptions = descriptions.join(', ');
      });

      return sectorGroup;
    });
  }

  function findGroupIdsFoundInEverySector(sectors) {
    let allGroupIdsInSectors = [];
    const unusedCreditsFoundInAllActiveGroupIds = [];

    _.forEach(sectors, (sector) => {
      _.forEach(sector.groups, (group) => {
        allGroupIdsInSectors.push(group.groupId);
      });
    });

    allGroupIdsInSectors = _.uniq(allGroupIdsInSectors);

    _.forEach(service.unusedCredits, (unusedCredit) => {
      let intersection = _.intersection(allGroupIdsInSectors, unusedCredit.SectorGroups);

      if (intersection.length === allGroupIdsInSectors.length) {
        unusedCreditsFoundInAllActiveGroupIds.push(unusedCredit);
      }
    });

    return unusedCreditsFoundInAllActiveGroupIds;
  }

  function addUnusedCredit(newUnusedCredit) {
    const allGroupIds = [];

    _.forEach(service.unusedCredits, (unusedCredit) => {
      if (unusedCredit.Payment.PaymentType != 'Invoice') {
        allGroupIds.push(unusedCredit.SectorGroups);
      }
    });

    const groupIds = _.flowRight(_.uniq, _.flatten)(allGroupIds);

    const newPaymentObj = {
      Payment: {
        ExpiryMonth: newUnusedCredit.cardExpiryMonth,
        ExpiryYear: newUnusedCredit.cardExpiryYear,
        Holder: newUnusedCredit.cardHolder,
        Number: newUnusedCredit.cardNumber,
        PaymentType: 'Card',
        Reference: null,
        SecurityCode: null,
        SecurityCodeRequired: true,
        Type: {
          Code: newUnusedCredit.Card.Type.Code,
          Value: newUnusedCredit.Card.Type.Code,
        },
      },
      SectorGroups: groupIds,
    };

    service.unusedCredits.push(newPaymentObj);
    service.activeAllSectors.push(newPaymentObj);
    service.activeSelectedAllPayment = newPaymentObj;
  }

  function groupSectorTypes(sectorGroups) {
    const sectorsByGroup = {
      flights: [],
      rails: [],
      hotels: [],
      cars: [],
    };

    _.forEach(sectorGroups, (sectorGroup) => {
      sectorsByGroup[sectorGroup.sectorType].push(sectorGroup);
    });

    return sectorsByGroup;
  }

  function combineGroupIds(sectorsByGroup) {
    const groupIDsBySectorType = {};

    _.forEach(sectorsByGroup, (sectors, sectorType) => {
      if (sectors.length > 0) {
        groupIDsBySectorType[sectorType] = [];
        _.forEach(sectors, (sector) => {
          _.forEach(sector.groups, (group) => {
            groupIDsBySectorType[sectorType].push(group.groupId);
          });
        });
      }
    });

    return groupIDsBySectorType;
  }

  function checkUnusedCreditsIncludeEveryGroupId(groupIDsBySectorType) {
    // forgive me
    const paymentsAvailableToEachSectorType = {};

    _.forEach(groupIDsBySectorType, (sectorGroupIds, sectorType) => {
      paymentsAvailableToEachSectorType[sectorType] = [];

      _.forEach(service.unusedCredits, (unusedCredit) => {
        const existsInAll = sectorGroupIds.every(function (v, i) {
          return unusedCredit.SectorGroups.indexOf(v) !== -1;
        });

        if (existsInAll) {
          paymentsAvailableToEachSectorType[sectorType].push(unusedCredit);
        }
      });
    });

    return paymentsAvailableToEachSectorType;
  }

  function getAllTravellerAllSectorsGrouped(groupedSectorPayments) {
    return _.flowRight(findUnusedCreditByGroupIds, findGroupIdsFoundInEverySectorGroup)(groupedSectorPayments);
  }

  function findGroupIdsFoundInEverySectorGroup(groupedSectorPayments) {
    const groupIds = [];

    _.forIn(groupedSectorPayments, (sectorPaymentGroup) => {
      _.forEach(sectorPaymentGroup, (sectorPayment) => {
        groupIds.push(sectorPayment.SectorGroups);
      });
    });

    return _.uniq(_.flatten(groupIds));
  }

  function findUnusedCreditByGroupIds(groupIds) {
    const matchedPayments = [];

    _.forEach(service.unusedCredits, (unusedCredit) => {
      if (_.difference(groupIds, unusedCredit.SectorGroups).length === 0) {
        matchedPayments.push(unusedCredit);
      }
    });

    return matchedPayments;
  }

  function populateEachPaxWithSelectedUnusedCredits(unusedCredits, travellers) {
    return matchPaymentsToTravellers(unusedCredits, travellers);
  }

  function matchPaymentsToTravellers(unusedCredits, travellers) {
    let paymentMissing = 0;

    _.forEach(travellers, (pax, paxIndex) => {
      const paymentsCopy = angular.copy(pax.Configurations.UnusedCredit.PaymentItems);
      pax.Configurations.UnusedCredit.PaymentItems = [];

      _.forEach(pax.Flights, (flight) => {
        if (unusedCredits.allPax && unusedCredits.allPax.flights) {
          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits.allPax.flights.Payment, flight.GroupIdentifier, 'Flight')
          );
        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier]) {
          if (!unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Flight', flight.GroupIdentifier);

            if (foundPayment.Card) {
              unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits[paxIndex + 2].flights[flight.GroupIdentifier].Payment, flight.GroupIdentifier, 'Flight')
          );
        } else {
          paymentMissing += 1;
        }
      });

      _.forEach(pax.Rails, (rail) => {
        if (unusedCredits.allPax && unusedCredits.allPax.rails) {
          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits.allPax.rails.Payment, rail.GroupIdentifier, 'Rail')
          );
        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier]) {
          if (!unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Rail', rail.GroupIdentifier);

            if (foundPayment.Card) {
              unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits[paxIndex + 2].rails[rail.GroupIdentifier].Payment, rail.GroupIdentifier, 'Rail')
          );
        } else {
          paymentMissing += 1;
        }
      });

      _.forEach(pax.Hotels, (hotel) => {
        if (unusedCredits.allPax && unusedCredits.allPax.hotels) {
          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits.allPax.hotels.Payment, hotel.GroupIdentifier, 'Hotel')
          );
        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier]) {
          if (!unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Hotel', hotel.GroupIdentifier);

            if (foundPayment.Card) {
              unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment, hotel.GroupIdentifier, 'Hotel')
          );
        } else {
          paymentMissing += 1;
        }
      });

      _.forEach(pax.Cars, (car) => {
        if (unusedCredits.allPax && unusedCredits.allPax.cars) {
          pax.Configurations.UnusedCredit.PaymentItems.push(buildPaymentObj(unusedCredits.allPax.cars.Payment, car.GroupIdentifier, 'Car'));
        } else if (unusedCredits[paxIndex + 2] && unusedCredits[paxIndex + 2].cars[car.GroupIdentifier]) {
          if (!unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment) {
            const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Car', car.GroupIdentifier);

            if (foundPayment.Card) {
              unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Card;
            } else {
              unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Invoice;
            }
          }

          pax.Configurations.UnusedCredit.PaymentItems.push(
            buildPaymentObj(unusedCredits[paxIndex + 2].cars[car.GroupIdentifier].Payment, car.GroupIdentifier, 'Car')
          );
        } else {
          paymentMissing += 1;
        }
      });
    });

    return {
      travellers: travellers,
      missingPayments: paymentMissing > 0,
    };
  }

  function doGroupIdsMatchToInvoiceUnusedCredit(grpIds, unusedCredits) {
    let typeInvoice = false;

    _.each(grpIds, (grpId) => {
      if (!typeInvoice) {
        _.each(unusedCredits, (payment) => {
          if (payment.SectorGroups.indexOf(grpId) > -1 && !typeInvoice && payment.Payment.PaymentType === 'Invoice') {
            typeInvoice = true;
          }
        });
      }
    });

    return typeInvoice;
  }

  function buildPaymentObj(Payment, grpId, type) {
    let paymentObj = {};

    if (Payment.PaymentType === 'Invoice') {
      paymentObj = {
        Card: null,
        Invoice: {
          PaymentType: 'Invoice',
          Reference: 'Invoice',
        },
        SectorGroupIdentifier: grpId,
        Type: type,
      };
    } else {
      paymentObj = {
        Card: Payment,
        Invoice: null,
        SectorGroupIdentifier: grpId,
        Type: type,
      };
    }

    return paymentObj;
  }

  function checkAllPaxPaymentsSelected(pax) {
    if (!pax) {
      return;
    }
    let eachSectorHasPayment = true;
    let sectorGrpIds = [];

    _.forEach(pax.Flights, (flight) => {
      sectorGrpIds.push(flight.GroupIdentifier);
    });

    _.forEach(pax.Rails, (rail) => {
      sectorGrpIds.push(rail.GroupIdentifier);
    });

    _.forEach(pax.Hotels, (hotel) => {
      sectorGrpIds.push(hotel.GroupIdentifier);
    });

    _.forEach(pax.Cars, (car) => {
      sectorGrpIds.push(car.GroupIdentifier);
    });

    sectorGrpIds = _.uniq(sectorGrpIds);

    sectorGrpIds.every((grpId) => {
      if (eachSectorHasPayment) {
        const findMatch = _.find(pax.Configurations.UnusedCredit.PaymentItems, (PaymentItem) => {
          return PaymentItem.SectorGroupIdentifier === grpId;
        });

        eachSectorHasPayment = !!findMatch;
      }

      return eachSectorHasPayment;
    });

    return eachSectorHasPayment;
  }

  function findPaymentWithTypeAndGrpId(payments, type, grpId) {
    return _.find(payments, (payment) => {
      return payment.SectorGroupIdentifier === grpId && payment.Type === type;
    });
  }

  function purgeDuplicateUnusedCredits(payments) {
    const grpIds = [];

    return _.filter(payments, (payment) => {
      if (grpIds.indexOf(payment.SectorGroupIdentifier) === -1) {
        grpIds.push(payment.SectorGroupIdentifier);
        return true;
      } else {
        return false;
      }
    });
  }

  function checkForCVV(PaymentItems, cvvObj) {
    let allCVVsPresent = true;

    PaymentItems.every((payment) => {
      if (allCVVsPresent && payment.Card && payment.Card.SecurityCodeRequired) {
        allCVVsPresent = cvvObj[payment.Card.Reference];
      }

      return allCVVsPresent;
    });

    return allCVVsPresent;
  }

  function addCVVsToPayments(paymentItems, cvvObj) {
    return _.forEach(paymentItems, (payment) => {
      if (payment.Card && payment.Card.SecurityCodeRequired) {
        payment.Card.SecurityCode = cvvObj[payment.Card.Reference];
      }
    });
  }

  return service;
};

unusedCreditsService.$inject = $inject;

export default unusedCreditsService;



// WEBPACK FOOTER //
// ./src/services/unusedCreditsService.js